'use client';
import { HTMLAttributes, useEffect, useState } from 'react';
import styled from 'styled-components';
import ContentText from '../atoms/ContentText';
import { useId } from 'react';

import Tag from './Tag';
import { UseFormRegisterReturn } from 'react-hook-form';
import { RadioButton } from './RadioButton';
import { InputTextNoError } from '../atoms/input/InputText';
import { StaticImageData } from 'next/image';

export type Option = {
  label: string;
  value: string;
  node?: React.ReactNode;
  disabled?: boolean;
  image?: StaticImageData;
};
type Props = {
  question?: string;
  required?: boolean;
  options: Option[];
  onchange: (value: string) => void;
  className?: string;
  defaultValue?: string;
  guide?: React.ReactNode;
  errorMessage?: string;
  register?: UseFormRegisterReturn<any>;
  isRadioGroupButton?: boolean;
  gap?: string;
  isLargeGuide?: boolean;
  id?: string;
};
const RadioGroup: React.FC<Props> = (props: Props) => {
  const [selectedOption, setSelectedOption] = useState<string | undefined>(
    props.defaultValue,
  );
  useEffect(() => {
    setSelectedOption(props.defaultValue);
  }, [props.defaultValue]);
  return (
    <div className={props.className} id={props.id}>
      {props.question && (
        <QuestionHeader>
          <ContentText type="label-l">{props.question}</ContentText>
          {props.required && (
            <Tag theme="error" small>
              必須
            </Tag>
          )}
        </QuestionHeader>
      )}

      {props.guide && (
        <ContentText
          type={props.isLargeGuide ? 'article-l' : 'article-m'}
          color={
            props.isLargeGuide
              ? 'var(--base-black, #000)'
              : 'var(--color-dark-gray, #585757)'
          }
        >
          {props.guide}
        </ContentText>
      )}
      <Wrapper $gap={props.gap}>
        {props.options.map((option, i) => {
          return (
            <div
              key={i}
              className={`${props.className}-option ${
                selectedOption == option.value ? 'active' : ''
              } `}
            >
              <RadioButton
                label={option.label}
                value={option.value}
                onChange={(e: any) => {
                  setSelectedOption(e.target.value);
                  props.onchange && props.onchange(e.target.value);
                }}
                selected={selectedOption == option.value}
                disabled={option.disabled}
                register={props.register}
                isRadioGroupButton={props.isRadioGroupButton}
                image={option.image}
              />
              {option.node}
            </div>
          );
        })}
      </Wrapper>
      {props.errorMessage && (
        <InputTextNoError>{props.errorMessage}</InputTextNoError>
      )}
    </div>
  );
};
const Wrapper = styled.div<{ $gap?: string }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $gap }) => $gap || '4px'};
  width: 100%;
`;
const QuestionHeader = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

export default RadioGroup;
